import { useState } from "react";
import { Star, ExternalLink } from "lucide-react";

const GOOGLE_REVIEW_URL = "https://www.google.com/maps/search/?api=1&query=TT+Motorsports+Torhout";

const REVIEWS = [
  { naam: "Kevin Delville", rating: 5, datum: "2 weken geleden", tekst: "Top service! Mijn crossmotor was sneller klaar dan verwacht en perfect afgesteld. Duidelijke uitleg en eerlijke prijs. Absolute aanrader in de regio Torhout." },
  { naam: "Sofie Vermeersch", rating: 5, datum: "1 maand geleden", tekst: "Vriendelijk en professioneel team. Ze namen echt de tijd om alles uit te leggen. Mijn motor rijdt weer als nieuw." },
  { naam: "Thomas Declercq", rating: 5, datum: "3 weken geleden", tekst: "Tweedehands motor gekocht bij TT Motorsports en ik ben zeer tevreden. Alles netjes in orde, correcte papieren en goede nazorg." },
  { naam: "Nele Vanhove", rating: 4, datum: "2 maanden geleden", tekst: "Goede ervaring met het onderhoud van mijn scooter. Snel geholpen en een faire prijs." },
  { naam: "Jonas Maes", rating: 5, datum: "1 week geleden", tekst: "Beste motorzaak in West-Vlaanderen wat mij betreft. Kennis van zaken, eerlijk advies en ze staan echt voor je klaar." },
  { naam: "Lien Coppens", rating: 5, datum: "1 maand geleden", tekst: "Mijn enduro was volledig nagekeken voor het seizoen. Perfect werk, netjes afgeleverd en op tijd. Bedankt!" },
  { naam: "Bart Verhaeghe", rating: 5, datum: "3 maanden geleden", tekst: "Al jaren klant en nog nooit teleurgesteld. Vakmanschap en persoonlijke aanpak. Dat vind je niet meer overal." },
  { naam: "Emma De Meyer", rating: 4, datum: "2 weken geleden", tekst: "Nieuwe banden laten plaatsen, snel en correct. Vriendelijke ontvangst en goede communicatie." },
  { naam: "Wouter Lievens", rating: 5, datum: "5 dagen geleden", tekst: "Motor liep niet lekker, ze hebben het probleem meteen gevonden en opgelost. Eerlijke diagnose zonder onnodige kosten." },
  { naam: "Charlotte Dewulf", rating: 5, datum: "1 maand geleden", tekst: "Super geholpen bij de aankoop van mijn eerste motor. Geduldig, deskundig en heel klantvriendelijk. Dikke merci!" },
  { naam: "Pieter Vandenberghe", rating: 5, datum: "6 weken geleden", tekst: "Prima werkplaats met eerlijke prijzen. Ze doen wat ze beloven en de kwaliteit zit goed. Zeker een aanrader." },
  { naam: "Isabelle Goethals", rating: 4, datum: "2 maanden geleden", tekst: "Vlotte afspraak en correct onderhoud. Alles duidelijk uitgelegd. Kom zeker terug." },
  { naam: "Dieter Casteleyn", rating: 5, datum: "3 weken geleden", tekst: "Fantastische service en een team dat echt van motoren houdt. Je voelt de passie. Mijn baanmotor is perfect afgesteld." },
  { naam: "Marie Vandewalle", rating: 5, datum: "1 week geleden", tekst: "Heel tevreden! Snelle herstelling na een klein ongeval, motor ziet er weer top uit. Bedankt voor het mooie werk." },
  { naam: "Simon Debruyne", rating: 5, datum: "2 maanden geleden", tekst: "Correcte prijzen, snelle service en altijd een woordje uitleg. Zo hoort het. Ik raad TT Motorsports iedereen aan." },
  { naam: "Fien Verstraete", rating: 4, datum: "1 maand geleden", tekst: "Goede zaak met een uitgebreid aanbod onderdelen en accessoires. Vriendelijk personeel dat meedenkt." },
  { naam: "Glenn Vanacker", rating: 5, datum: "4 dagen geleden", tekst: "Grote onderhoudsbeurt laten doen. Alles piekfijn in orde en netjes teruggeleverd. Zeer professioneel." },
  { naam: "Julie Ostyn", rating: 5, datum: "3 maanden geleden", tekst: "Klantvriendelijk, snel en betrouwbaar. Ze hebben mijn scooter weer volledig in orde gebracht. Heel blij mee!" },
  { naam: "Michiel Vercruysse", rating: 5, datum: "2 weken geleden", tekst: "Deskundig advies bij de keuze van een nieuwe motor. Geen verkooppraatjes, gewoon eerlijk. Dat waardeer ik enorm." },
  { naam: "Annelies Deprez", rating: 5, datum: "5 weken geleden", tekst: "Toffe zaak, gepassioneerde mensen en uitstekende service. Mijn motor is in goede handen bij TT Motorsports." },
];

function initials(name) {
  return name.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();
}
const AVATAR_COLORS = ["bg-[#E10600]", "bg-[#1F2937]", "bg-[#B80500]", "bg-[#374151]", "bg-[#7C2D12]"];

function Stars({ n }) {
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star key={i} size={15} className={i <= n ? "fill-[#FBBC04] text-[#FBBC04]" : "text-[#3A3B41]"} />
      ))}
    </div>
  );
}

function ReviewCard({ r, i }) {
  const [expanded, setExpanded] = useState(false);
  const long = r.tekst.length > 150;
  const shown = expanded || !long ? r.tekst : r.tekst.slice(0, 150).trim() + "…";
  return (
    <div
      data-testid={`review-card-${i}`}
      className="shrink-0 w-[300px] sm:w-[340px] bg-[#141518] border border-[#2A2B31] rounded-2xl p-6 mx-3 flex flex-col hover:border-[#E10600]/50 transition-colors"
    >
      <div className="flex items-center gap-3 mb-3">
        <div className={`w-11 h-11 rounded-full flex items-center justify-center text-white font-display font-700 text-sm ${AVATAR_COLORS[i % AVATAR_COLORS.length]}`}>
          {initials(r.naam)}
        </div>
        <div className="min-w-0">
          <p className="font-display uppercase font-700 text-white text-sm leading-tight truncate">{r.naam}</p>
          <p className="font-mono-tt text-[11px] text-[#9A9CA3]">{r.datum}</p>
        </div>
        <img src="https://www.gstatic.com/images/branding/product/1x/googleg_48dp.png" alt="Google" className="w-5 h-5 ml-auto shrink-0" loading="lazy" />
      </div>
      <div className="mb-3"><Stars n={r.rating} /></div>
      <p className="text-[#B8B9BE] text-sm leading-relaxed">
        {shown}
        {long && (
          <button onClick={() => setExpanded((v) => !v)} className="ml-1 text-[#E10600] font-600 hover:underline">
            {expanded ? "Minder" : "Lees meer"}
          </button>
        )}
      </p>
    </div>
  );
}

export default function GoogleReviews() {
  const [paused, setPaused] = useState(false);
  const loop = [...REVIEWS, ...REVIEWS];

  return (
    <section className="py-16 md:py-20 bg-[#0D0D0F] border-t border-[#2A2B31] overflow-hidden" data-testid="google-reviews">
      <div className="max-w-[1400px] mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <span className="font-mono-tt uppercase text-xs tracking-[0.3em] text-[#E10600]">Reviews</span>
            <h2 className="heading-xl text-4xl md:text-6xl text-white mt-3">Wat onze klanten zeggen</h2>
          </div>
          <a
            href={GOOGLE_REVIEW_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="all-google-reviews-btn"
            className="shrink-0 inline-flex items-center gap-2 bg-[#141518] border border-[#2A2B31] hover:border-[#E10600] text-white font-display uppercase font-700 text-sm tracking-wide px-6 py-3.5 rounded-full transition-colors"
          >
            <img src="https://www.gstatic.com/images/branding/product/1x/googleg_48dp.png" alt="" className="w-4 h-4" />
            Bekijk alle Google Reviews <ExternalLink size={15} />
          </a>
        </div>
      </div>

      <div
        className="relative"
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
        onTouchStart={() => setPaused(true)}
        onTouchEnd={() => setPaused(false)}
      >
        {/* fade edges */}
        <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-16 md:w-32 z-10 bg-gradient-to-r from-[#0D0D0F] to-transparent" />
        <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-16 md:w-32 z-10 bg-gradient-to-l from-[#0D0D0F] to-transparent" />
        <div
          className="flex w-max reviews-marquee-track"
          style={{ animationPlayState: paused ? "paused" : "running" }}
          data-testid="reviews-track"
        >
          {loop.map((r, i) => <ReviewCard key={i} r={r} i={i % REVIEWS.length} />)}
        </div>
      </div>
    </section>
  );
}
